<template>
  <div class="tool-bar">
    <div class="rotate-btn" @click="pdfRotate(-90)">
      <span class="rotate-btn-left"></span>
    </div>
    <div class="zoom-btn" @click="zoom(-1)">
      <span >-</span>
    </div>
    <span class="zoom-text">{{ size[sizeIndex] + "%" }}</span>
    <div class="zoom-btn" @click="zoom(1)">
      <span  >+</span>
    </div>
    <div class="rotate-btn" @click="pdfRotate(90)">
      <span class="rotate-btn-right"></span>
    </div>
  </div>
  <div class="pdf" v-if="url">
    <template v-for="item in pageNum" :key="item">
      <canvas :id="`pdf-canvas-${item}`" class="pdf-page" />
    </template>
  </div>
</template>
<script>
import { reactive, toRefs, nextTick, watchEffect } from "vue";
import {PDFSIZERANGE} from "@/util/data.js"
const PDF = require("pdfjs-dist");
PDF.GlobalWorkerOptions.workerSrc = "/pdf.worker.js";
export default {
  props: {
    url: {
      default: "",
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      pageNum: 0,
      pdfCtx: null,
      size:PDFSIZERANGE,
      sizeIndex: 7,
      rotate:0
    });
    watchEffect(() => {
      if (props.url) {
        nextTick(() => {
          resolvePdf(props.url);
        });
      }
    });
    const resolvePdf = (url) => {
      let pdfData = window.atob(url);
      const loadingTask = PDF.getDocument({ data: pdfData,cMapUrl:`https://unpkg.com/pdfjs-dist@${PDF.version}/cmaps/`,cMapPacked:true });
      loadingTask.promise.then((pdf) => {
        let pdfCtx = pdf;
        state.pageNum = pdf.numPages;
        nextTick(() => {
          renderPdf(pdfCtx);
        });
      });
    };
    const renderPdf = (pdfCtx, num = 1) => {
      pdfCtx.getPage(num).then((page) => {
        const canvas = document.getElementById(`pdf-canvas-${num}`);
        const ctx = canvas.getContext("2d");
        let config = {
          scale: 1 ,
          rotation:0
        }
        if("_pageInfo" in page && "view" in page._pageInfo && page._pageInfo.view.length>3){
          let viewWidth = page._pageInfo.view[2]
          let viewHeight = page._pageInfo.view[3]
          if(viewWidth>viewHeight){
            config.rotation = 90
          } else {
            config.rotation = 0
          }
        }
        const viewport = page.getViewport(config);
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        canvas.style.width = "100%";
        canvas.style.height = "auto";
        page.render({
          canvasContext: ctx,
          viewport,
        });
        if (num < state.pageNum) {
          renderPdf(pdfCtx, num + 1);
        } else {
          emit("onRendered");
        }
      });
    };
    // 縮小 拡大
    const zoom = (step) => {
      if (step == -1 && state.sizeIndex == 0) {
        return;
      }
      if (step == 1 && state.sizeIndex >= state.size.length - 1) {
        return;
      }
      state.sizeIndex = state.sizeIndex + step;
      let scale = state.size[state.sizeIndex] / 100;
      for (let index = 0; index < state.pageNum; index++) {
        let item = document.getElementById(`pdf-canvas-${index + 1}`);
        let widthTemp = 100;
        item.style.width = parseInt(widthTemp) * scale + "%";
      
      }
    };
    const pdfRotate = (step) => {
      if(state.rotate%360 == 0){
        state.rotate = 0
      }
      state.rotate =　state.rotate　+ step
      for (let index = 0; index < state.pageNum; index++) {
        let item = document.getElementById(`pdf-canvas-${index + 1}`);
        item.style.transform = `rotate(${state.rotate}deg)`
      
      }
    }
    // 拡大

    return {
      zoom,
      pdfRotate,
      ...toRefs(state),
    };
  },
};
</script>
<style>
.pdf {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 44px;
  overflow: auto;
  background-color: #f2f2f2;
}
.pdf canvas {
  display: block;
  margin-bottom: 10px;
}
.tool-bar {
  position: absolute;
  width: 100%;
  /* height: 30px; */
  background-color: rgba(62, 62, 62, 1);
  color: #fff;
  top: 0;
  left: 0;
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
  z-index:1;
}
.zoom-text{
  display: inline-block;
  width: 4em;
  text-align: center;
}
.tool-bar > .zoom-btn,.tool-bar > .rotate-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: rgba(80, 79, 79, 1);
  margin: 0 10px;
}
.rotate-btn-right,.rotate-btn-left{
  display: inline-block;
  width: 100%;
  height: 100%;
  background-size: 60% 60%;
  background-position: center;
}

.rotate-btn-left{
  background-image: url("../assets/images/denchouhou/rotate-left.png") ;
}
.rotate-btn-right{
  background-image: url("../assets/images/denchouhou/rotate-right.png") ;
}
</style>